module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-page"
  }, [_c('p', {
    staticClass: "page-title"
  }, [_vm._v("最新动态")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "new-page-wp"
  }, [_c('h2', {
    staticClass: "new-page-title"
  }, [_vm._v(_vm._s(_vm.Detail.title))]), _vm._v(" "), _c('p', {
    staticClass: "new-page-text1"
  }, [_c('span', [_vm._v("媒体来源：" + _vm._s(_vm.Detail.author))]), _c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.Detail.creationTime, 'YYYY-MM-DD')))])]), _vm._v(" "), _c('div', {
    staticClass: "ql-container ql-snow"
  }, [_c('div', {
    staticClass: "ql-editor"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.Detail.body)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "new-page-btn"
  }, [_c('router-link', {
    attrs: {
      "to": "/Articles"
    }
  }, [_c('el-button', {
    attrs: {
      "plain": true,
      "type": "info"
    }
  }, [_vm._v("返回")])], 1)], 1)])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('v-card', [_c('div', [_c('p', [_vm._v("相关内容")]), _vm._v(" "), _c('div', {
    staticClass: "articleBoxHead"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ArticleListPage',
        params: {
          tabs: 'company'
        }
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "plain": true,
      "size": "small"
    }
  }, [_vm._v("公司新闻")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ArticleListPage',
        params: {
          tabs: 'industry'
        }
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "plain": true,
      "size": "small"
    }
  }, [_vm._v("行业新闻")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ArticleListPage',
        params: {
          tabs: 'media'
        }
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "plain": true,
      "size": "small"
    }
  }, [_vm._v("媒体关注")])], 1)], 1)]), _vm._v(" "), _vm._l((_vm.NewsList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "articleLine",
      on: {
        "click": function($event) {
          _vm.articleChange(item.id)
        }
      }
    }, [_c('span', {
      staticClass: "articleLineTitle"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "articleLineDate"
    }, [_vm._v(_vm._s(_vm._f("date")(item.creationTime, 'YYYY-MM-DD')))])])
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38757e68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Articles/ArticleDetail.vue
// module id = 721
// module chunks = 0